module.exports = "<div >\n    <div class=\"flex filter-container filter-backups\">\n        <div class=\"filter-title\">Filters</div>\n        <div class=\"dbm dbm-back-icon\" (click)=\"isCollapsed = !isCollapsed\"\n             [ngClass]=\"isCollapsed? 'expanded': 'collapsed'\"></div>\n    </div>\n    \n    <backups-filter *ngIf=\"!isCollapsed\" (filter)= \"filter($event)\" (getEnvs)=\"setEnvs($event)\"></backups-filter>\n    <backups-data  (deleteItem) = \"deleteItem($event)\" [data]=\"backups\"></backups-data> \n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/buckups-ang7/backups.component.html
// module id = 1726
// module chunks = 0